<template>
  <div id="zoomBackgrounds">
      <Tab isZoom="true" />
      <section>
        <ul class="zoom-bgs">
            <li class="white-bg zoom-bg"><a href="/static/zoom/Zoom-0.png" download><img src="/static/zoom/Zoom-0.png" alt="Zoom背景0"></a></li>
            <li class="white-bg zoom-bg"><a href="/static/zoom/Zoom-1.png" download><img src="/static/zoom/Zoom-1.png" alt="Zoom背景1"></a></li>
            <li class="white-bg zoom-bg"><a href="/static/zoom/Zoom-2.png" download><img src="/static/zoom/Zoom-2.png" alt="Zoom背景2"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-3.png" download><img src="/static/zoom/Zoom-3.png" alt="Zoom背景3"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-4.png" download><img src="/static/zoom/Zoom-4.png" alt="Zoom背景4"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-5.png" download><img src="/static/zoom/Zoom-5.png" alt="Zoom背景5"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-6.png" download><img src="/static/zoom/Zoom-6.png" alt="Zoom背景6"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-7.png" download><img src="/static/zoom/Zoom-7.png" alt="Zoom背景7"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-8.png" download><img src="/static/zoom/Zoom-8.png" alt="Zoom背景8"></a></li>
            <li class="white-bg zoom-bg"><a href="/static/zoom/Zoom-9.png" download><img src="/static/zoom/Zoom-9.png" alt="Zoom背景9"></a></li>
            <li class="zoom-bg"><a href="/static/zoom/Zoom-10.png" download><img src="/static/zoom/Zoom-10.png" alt="Zoom背景10"></a></li>
        </ul>
      </section>
  </div>
</template>

<script>
import Tab from '../Atoms/Tab'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'zoomBackgrounds',
  components: {
    Tab
  },
  mounted: function () {
    this.scrollItem()
  },
  methods: {
    scrollItem: function () {
      gsap.to('.zoom-bg', {
        scrollTrigger: {
          trigger: '.zoom-bgs',
          start: 'top 90%',
          end: 'top center',
          markers: false
        },
        y: 0,
        opacity: 1,
        duration: 0.3,
        stagger: {
          each: 0.1,
          from: 'start',
          grid: 'auto',
          ease: 'power2.inOut'
        }
      })
    }
  }
}
</script>

<style scoped>
section {
  margin-top: 9.6rem;
}
ul {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px,1fr));
  gap: 3.2rem;
}
li {
  border-radius: 1.2rem;
  overflow: hidden;
  opacity: 0;
  transform: translateY(48px);
  transition: box-shadow 0.5s;
}

li:hover {
  box-shadow: 0 0.8rem 3.2rem 0 rgba(0,0,0, 0.2);
  transition: 0.1s;
}

li a img {
  width: 100%;
  height: auto;
  vertical-align: bottom;
}

.white-bg {
  border: solid 1px var(--light-gray);
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ZoomBackgrounds.vue